import DefaultContainer from '../default_container';
import './index_web.css';

const SelectAvatarWeb = ({
  avatarList,
  onSelectAvatar,
  avatarId,
  selectedBtnStyle,
  freeBtnStyle
}: any) => {
  return (
    <DefaultContainer isWelcomeMessage={false}>
      <div className="select_avatar_wrapper">
        <div className="select_avar_primary_container">
          <div className="select_avatar_primary_img_wrapper">
            <img className="select_avatar_img" src={avatarList[avatarId]} />
          </div>
          <div className="title">Select An Avatar</div>
        </div>

        <div className="select_avatar_list_wrapper">
          {Object.values(avatarList).map((item: any, idx: any) => (
            <div className="select_avatar_list_container" key={idx}>
              <div className="avatar_container">
                <div className="avatar_img_container">
                  <img className="avatar_img" src={item} />
                </div>
                {idx === avatarId ? (
                  <button className="avatar_btn selected" style={selectedBtnStyle}>
                    SELECTED
                  </button>
                ) : (
                  <button
                    className="avatar_btn free"
                    style={freeBtnStyle}
                    onClick={() => onSelectAvatar(idx)}>
                    FREE
                  </button>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </DefaultContainer>
  );
};

export default SelectAvatarWeb;
